"use client"

import { usePathname } from "next/navigation"

export function ContentNullWhere({ children, where }: { children: React.ReactNode, where: string[] }) {
  const pathname = usePathname()
  if (where.includes(pathname)) return null
  return <>{children}</>
}